import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import ReactDatePicker from "react-datepicker";
import { Table } from "react-bootstrap";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../../../constants";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { getDay } from "date-fns";
import LeaveHistory from "./LeaveHistory";
import LeaveSummary from "./LeaveSummary";
import { FileUploader } from "./components/MultipleFileUploader";

const EditApplyLeave = () => {
  const initialFormData = {
    FromDate: null,
    ToDate: null,
    EmployeeID: "",
    dates: "",
    Purpose: "",
    revisionNumber: "",
    leaveID: "",
    rowstatus: 436,
    leavesFile: null,
    FilePath: "",
  };

  const { id } = useParams();
  const navigate = useNavigate();
  let today = moment().format("DD-MMM-YYYY");
  const [leaveDetails, setLeaveDetails] = useState([]);
  const [daysDifference, setDaysDifference] = useState(0);
  const [displayedDates, setDisplayedDates] = useState([
    moment().format("DD-MMM-YYYY"),
  ]);
  const [errors, setErrors] = useState({});
  const [leaveSummary, setLeaveSummary] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [leaveoptions, setLeaveOptions] = useState([]);
  const [leaveHistory, setLeaveHistory] = useState([]);
  const [statusoptions, setStatusOptions] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [OriginalLineData, setOriginalLineData] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Apply Leave"));
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const location = useLocation();
  const { disabledDatess } = location.state || [];

  const [holidayDate, setHolidayDate] = useState(disabledDatess);
  const [pageLoading, setPageLoading] = useState(true);
  const [empDetails, SetEmpDetails] = useState([]);
  const fetchLeaveDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}apply-leave`);

      if (response?.status === 200) {
        const empDetails = response?.data?.data[0];
        SetEmpDetails(empDetails);
        setFormData((prevData) => ({
          ...prevData,
          isCalCulated: 0,
          EmployeeID: empDetails?.DefaultContactID,
          revisionNumber: empDetails?.RevisionNumber ?? 0, // Updating revisionNumber
        }));
        const data = response?.data?.leaveSummary;
        const leaveHistory = response?.data?.leaveHistory;
        setLeaveHistory(leaveHistory);
        setLeaveDetails(data);

        // Filter out the unwanted LeaveID and LeaveType
        const filteredData = data.filter(
          (comp) => !(comp.LeaveID === 3 && comp.LeaveType === "Total")
        );

        const leaveopt = filteredData.map((comp) => ({
          value: comp.LeaveID,
          label: comp.LeaveType,
        }));
        setLeaveOptions(leaveopt);
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    fetchLeaveDetails();
  }, []);

  const filteredLeaveDetails = leaveDetails.filter((item) =>
    ["C-Off", "EL", "LOP", "Total"].includes(item.LeaveType)
  );
  const countWeekdays = (startDate, endDate) => {
    let count = 0;
    let currentDate = moment(startDate);

    while (
      currentDate.isBefore(endDate) ||
      currentDate.isSame(endDate, "day")
    ) {
      if (isWeekday(currentDate.toDate())) {
        count++;
      }
      currentDate.add(1, "days");
    }
    return count;
  };

  const [newLeveLineAdded, setNewLeveLineAdded] = useState([]);

  const handleDateChange = (date, field) => {
    const formattedDate = moment(date).format("DD-MMM-YYYY");
    const fromDate = field === "FromDate" ? formattedDate : formData.FromDate;
    const toDate = field === "ToDate" ? formattedDate : formData.ToDate;

    if (moment(toDate, "DD-MMM-YYYY").isBefore(moment(fromDate, "DD-MMM-YYYY"))) {
      // Show toast message and return without updating state
      toast.error("To Date cannot be before From Date!");
      return;
    }

    // Update form data
    setFormData((prev) => ({
      ...prev,
      FromDate: fromDate,
      ToDate: toDate,
    }));

    // Copy leave balances
    let remainingCOff =
      filteredLeaveDetails.find((l) => l.LeaveType === "C-Off")?.LeaveBalance ||
      0;
    let remainingEL =
      filteredLeaveDetails.find((l) => l.LeaveType === "EL")?.LeaveBalance || 0;

    // Prepare new date range set
    const newDates = generateDateRange(fromDate, toDate);
    const newDateSet = new Set(
      newDates.map((d) => moment(d, "DD-MMM-YYYY").format("YYYY-MM-DD"))
    );

    // Get the last LineNo from existing lineData
    const lastLineNo =
      lineData.length > 0
        ? Math.max(...lineData.map((line) => line.LineNo))
        : 0;

    // Create a map of existing entries to avoid duplicate creation
    const existingDateMap = {};
    lineData.forEach((line) => {
      const lineDate = moment(line.Date).format("YYYY-MM-DD");
      existingDateMap[lineDate] = line;
    });

    let currentLineNo = lastLineNo;
    const updatedLines = [];
    const newLeaveLines = [];

    newDates.forEach((d) => {
      const formatted = moment(d, "DD-MMM-YYYY").format("YYYY-MM-DD");

      // Skip if already existing and TXNID !== 0 (means already stored in DB)
      if (
        existingDateMap[formatted] &&
        existingDateMap[formatted].TXNID !== 0
      ) {
        updatedLines.push(existingDateMap[formatted]);
        return;
      }

      let leaveID = 3;
      if (remainingCOff > 0) {
        leaveID = 1; // Comp Off
        remainingCOff--;
      } else if (remainingEL > 0) {
        leaveID = 2; // EL
        remainingEL--;
      }

      currentLineNo += 1;

      const newLine = {
        TXNID: 0,
        LineNo: currentLineNo,
        Date: formatted,
        LeaveID: leaveID,
        RowState: 435,
        WorkingStatus_053: 234,
        ApplicationStatus_123: 824,
        CreatedBy: 904,
        ModifiedBy: 904,
        CreatedDate: new Date().toISOString(),
        ModifiedDate: new Date().toISOString(),
        Remarks: null,
        RevisionNumber: 1,
      };

      updatedLines.push(newLine);
      newLeaveLines.push(newLine);
    });
    setLineData(updatedLines);
    setNewLeveLineAdded(newLeaveLines);
    setDaysDifference(
      countWeekdays(
        moment(fromDate, "DD-MMM-YYYY"),
        moment(toDate, "DD-MMM-YYYY")
      )
    );
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // Function to generate the date range excluding weekends
  const generateDateRange = (fromDate, toDate) => {
    let currentDate = moment(fromDate, "DD-MMM-YYYY");
    const endDate = moment(toDate, "DD-MMM-YYYY");
    let dates = [];

    while (currentDate <= endDate) {
      if (
        currentDate.isoWeekday() !== 6 &&
        currentDate.isoWeekday() !== 7 &&
        !holidayDate.some((disabledDate) =>
          moment(disabledDate).isSame(currentDate, "day")
        )
      ) {
        // Exclude Saturday (6) and Sunday (7)
        dates.push(currentDate.format("DD-MMM-YYYY"));
      }
      currentDate = currentDate.add(1, "days");
    }

    return dates;
  };

  const isWeekday = (date) => {
    const day = moment(date).isoWeekday(); // 6 = Saturday, 7 = Sunday
    const isWeekend = day === 6 || day === 7;

    const isHoliday = disabledDatess.some((disabledDate) =>
      moment(disabledDate, "DD-MMM-YYYY").isSame(moment(date), "day")
    );

    // ✅ Respect minDate & maxDate restrictions
    const minDate =
      formData?.isCalCulated !== 0
        ? moment().startOf("month") // Only current month
        : moment().subtract(1, "months").startOf("month"); // Last month allowed

    const maxDate =
      moment().add(4, "months").endOf("month").year() > moment().year()
        ? moment().endOf("year")
        : moment().add(4, "months").endOf("month");

    const isOutOfRange =
      moment(date).isBefore(minDate, "day") || moment(date).isAfter(maxDate, "day");

    return !isWeekend && !isHoliday && !isOutOfRange;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.Purpose) newErrors.Purpose = "Purpose is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [employeeData, setEmployeeData] = useState([]);
  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}apply-leave/${id}`);

      if (response.status === 200) {
        const EmpDAta = response?.data?.data?.[0];

        setEmployeeData(EmpDAta);
        const leaveData = response?.data?.leaveList;
        const lineData = response?.data?.leaveLine;

        setLineData(
          lineData?.map((o) => ({
            ...o,
            RowState: 437,
            EmployeeID: response?.data?.data?.[0]?.DefaultContactID,
          }))
        );
        setOriginalLineData(
          lineData?.map((o) => ({
            ...o,
            RowState: 437,
            EmployeeID: response?.data?.data?.[0]?.DefaultContactID,
          }))
        );
        const leaveSummary = response?.data?.leaveSummary;
        setLeaveSummary(leaveSummary);
        const leaveHistory = response?.data?.leaveHistory;
        setLeaveHistory(leaveHistory);

        const statusoption = response?.data?.status;
        const filteredStatus = statusoption.filter(
          (comp) => comp.value === 1132 || comp.value === 824
        );
        const statusopt = filteredStatus.map((comp) => ({
          value: comp.value,
          label: comp.text,
        }));
        setStatusOptions(statusopt);

        if (leaveData) {
          const { Purpose, FromDate, ToDate } = leaveData;
          setFormData((prevData) => ({
            ...prevData,
            id: id || "",
            Purpose: Purpose || "",
            FromDate: FromDate ? moment(FromDate).format("DD-MMM-YYYY") : "",
            ToDate: ToDate ? moment(ToDate).format("DD-MMM-YYYY") : "",
            applicationStatus: leaveData?.ApplicationStatus_123,
            leavesFile: leaveData?.FileName,
            FilePath: leaveData?.FilePath,
            canBeDisable: leaveData?.ApplicationStatus_123 == 1132 ? 1 : 0,
          }));
          setFileName(leaveData?.FileName);
        } else {
          console.error("Leave Data not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch Leave details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave details:", error);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Step 1: Find max LineNo from existing lineData
      const lineDataMaxLineNo = Math.max(...lineData.map(item => item.LineNo || 0));
      const finalData = [...OriginalLineData, ...newLeveLineAdded] // Here we added NewLeave Object and Object get in Show API


      // Step 2: Create new leaveData with incremented LineNos
      const leaveData = lineData?.map((item, index) => ({
        TXNID: item?.TXNID,
        LineNo: lineDataMaxLineNo + index + 1, // ensure unique LineNo
        RowState: 435,
        RevisionNumber: item?.RevisionNumber,
        Date: item?.Date,
        LeaveID: item?.LeaveID,
        ApplicationStatus_123: item?.ApplicationStatus_123,
        WorkingStatus_053: item?.WorkingStatus_053,
        Remarks: item?.Remarks ? item?.Remarks : "Internal",
        EmployeeID: employeeData?.DefaultContactID,
      }));

      // Step 3: Merge lineData and leaveData into one array
      const combinedLines = [...OriginalLineData, ...leaveData];
      // Step 4: Set into formData
      const updatedFormData = {
        ...formData,
        leaveApplicationLines:
          formData?.applicationStatus === 1132
            ? OriginalLineData?.map((o) => ({ ...o, RowState: 436 }))
            : combinedLines,
      };

      // Step 5: Update state and submit
      setFormData(updatedFormData);
      setSubmit(true);

      PostFormServiceCaller(
        `${API_URL}pendingorcancel-leave/${id}`,
        updatedFormData,
        "post"
      )
        .then((response) => {
          toast.success("Leave updated successfully!");
          navigate("/apply-leave");
          setSubmit(false);
        })
        .catch((error) => {
          setSubmit(false);
          console.error("Error submitting the form:", error);
        });
    }
  };

  const handleCancel = () => {
    navigate("/apply-leave");
  };

  let remainingCOff =
    filteredLeaveDetails.find((leave) => leave.LeaveType === "C-Off")
      ?.LeaveApplied || 0;
  let remainingEL =
    filteredLeaveDetails.find((leave) => leave.LeaveType === "EL")
      ?.LeaveApplied || 0;

  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const handleFile = (files) => {
    if (files) {
      const selectedFile = files;

      // Create object URL
      const url = URL.createObjectURL(selectedFile);
      setFileUrl(url); // Store the URL

      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        leavesFile: "",
      }));

      setFile(selectedFile);
      setFileName(selectedFile.name);

      setFormData((prevState) => ({
        ...prevState,
        leavesFile: selectedFile,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        leavesFile:
          "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };

  // Don't forget to revoke the object URL when component unmounts
  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);
  const handleEdit = (id) => {
    navigate(`/apply-leave/edit/${id}`, { state: { disabledDatess } });
  };




  useEffect(() => {
    if (pageLoading) {

      // Get current date, subtract 1 month, and get the last day of that month
      const lastMonthLastDate = moment().subtract(1, 'month').endOf('month');
      fetchCalCulatedpayrollData(moment(lastMonthLastDate).format("YYYY-MM-DD"));
    }
  }, [pageLoading]);



  const fetchCalCulatedpayrollData = async (date) => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}get-calculated-payroll?current_date=${date}`)
      if (response?.status == 200) {
        console.log("response?.data?.data?.payrollCalculated", response?.data?.data?.payrollCalculated);

        setFormData((prevData) => ({
          ...prevData,
          isCalCulated: response?.data?.data?.payrollCalculated,
        }))
      }
    } catch (error) {
      console.error("Fetching API Error", error);

    }
  }

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-7">
              <div className="container-fluid" id="skill-table-area">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <label for="leave-type" class="form-label">
                        Employee Name<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="EmployeeName"
                        aria-describedby="EmployeeName"
                        name="EmployeeName"
                        value={leaveSummary?.[0]?.EmployeeName || ""}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label for="leave-type" class="form-label">
                        Status<span className="required">*</span>
                      </label>
                      <Select
                        value={statusoptions.find(
                          (option) =>
                            option.value === formData.applicationStatus
                        )}
                        options={statusoptions}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            applicationStatus: selectedOption
                              ? selectedOption.value
                              : null,
                          })
                        }
                      />
                    </div>
                    <div className="mt-2">
                      <label for="leave-type" class="form-label">
                        Purpose<span className="required">*</span>
                      </label>
                      <textarea
                        type="text"
                        className={`form-control ${errors.Purpose ? "is-invalid" : ""
                          }`}
                        id="Purpose"
                        aria-describedby="Purpose"
                        name="Purpose"
                        value={formData.Purpose}
                        onChange={handleInputChange}
                      />
                      {errors.Purpose && (
                        <div className="invalid-feedback">{errors.Purpose}</div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="TargetDate" className="form-label">
                        From Date<span className="required">*</span>
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="FromDate"
                        id="FromDate"
                        filterDate={isWeekday}
                        onChange={(date) => handleDateChange(date, "FromDate")}
                        selected={
                          formData.FromDate
                            ? moment(formData.FromDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        minDate={
                          formData?.isCalCulated !== 0
                            ? moment().startOf("month").toDate()
                            : moment().subtract(1, "months").startOf("month").toDate()
                        } maxDate={
                          moment().add(4, "months").endOf("month").year() > moment().year()
                            ? moment().endOf("year").toDate() // ✅ Limit to December 31
                            : moment().add(4, "months").endOf("month").toDate()
                        }

                      />

                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="TargetDate" className="form-label">
                        To Date<span className="required">*</span>
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        // minDate={new Date()}
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="ToDate"
                        id="ToDate"
                        filterDate={isWeekday}
                        onChange={(date) => handleDateChange(date, "ToDate")}
                        selected={
                          formData.ToDate
                            ? moment(formData.ToDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        minDate={
                          formData?.isCalCulated !== 0
                            ? moment().startOf("month").toDate()
                            : moment().subtract(1, "months").startOf("month").toDate()
                        } maxDate={
                          moment().add(4, "months").endOf("month").year() > moment().year()
                            ? moment().endOf("year").toDate() // ✅ Limit to December 31
                            : moment().add(4, "months").endOf("month").toDate()
                        }

                      />
                    </div>
                    <div className="col-sm-12 col-md-2 mt-2">
                      <div class="mb-3">
                        <label for="days" class="form-label">
                          No. of Days
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          id="days"
                          aria-describedby="days"
                          name="days"
                          value={
                            daysDifference ? daysDifference : lineData.length
                          }
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-12 mt-4">
                      <Table bordered>
                        <thead id="thcolor" className="text-center">
                          <tr>
                            <th className="py-1 px-2">Sr. No.</th>
                            <th className="py-1 px-2">Date</th>
                            <th className="py-1 px-2">Leave Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lineData.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </td>
                                <td>
                                  <Select
                                    value={leaveoptions.find(
                                      (o) => o?.value == item.LeaveID
                                    )}
                                    options={leaveoptions}
                                    isDisabled={true}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-4">
                          <FileUploader
                            handleFile={handleFile}
                            accept=".pdf,.doc,.docx" // Specify accepted file types
                          />
                        </div>
                      </div>
                      {fileName && (
                        <div className="mt-2">
                          Selected file:{" "}
                          <a
                            href={formData?.FilePath || fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {fileName}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="text-end">
                    <button
                      type="button"
                      className="cancel-btn me-2"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className={`custom-btn ${formData?.canBeDisable ? "disabled-icon" : ""
                        }`}
                      onClick={handleSubmit}
                      disabled={formData?.canBeDisable}
                    >
                      {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-12 col-lg-5">
              <div className="row">
                <LeaveSummary leaveDetails={leaveSummary} />
              </div>
              <div className="row">
                <LeaveHistory
                  onEdit={handleEdit}
                  leaveHistory={leaveHistory}
                  showAction={true}
                  title="Leave History"
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default EditApplyLeave;
